export const brlFormatterNative = new Intl.NumberFormat("pt-Br", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
});

export const formatBRCurrency = (value: number) => {
  return brlFormatterNative.format(value / 100);
};
